import { Heading } from 'components/text';
import Image from 'next/image';
import styles from './HeroSection.module.scss';
import Container from 'components/container';
import { travelJournalHeroWEBP } from 'assets';
import { TravelJournalCategoryType } from 'types/types';
import CategoryLink from '../category-link/CategoryLink';

interface HeroSectionProps {
  categories: TravelJournalCategoryType[];
}

const HeroSection: React.FC<HeroSectionProps> = ({ categories }) => {
  return (
    <Container as="header" className={styles.heroSection}>
      <h1 className={styles.title}>Travel Journal</h1>
      <Image
        src={travelJournalHeroWEBP}
        objectPosition="center"
        objectFit="cover"
        alt="Travel Journal"
        layout="fill"
        sizes="200vw"
      />
      <nav className={styles.categories}>
        {categories.map(category => (
          <CategoryLink key={category.id} category={category}>
            {category.name}
          </CategoryLink>
        ))}
      </nav>
      <Container className={styles.bottomGradient} />
    </Container>
  );
};

export default HeroSection;
